import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useLocale } from '../../utils/LocaleContext';

// ─── Static fallback carriers (commented out — no longer used for initialization) ───
// const MOCK_CARRIERS = [
//   { id: '1', name: 'Zurich Insurance Group AG',  code: 'ZURI', products: ['Professional Liability', 'Legal Protection'], activePolicies: 68,  monthlyPremium: 420000, status: 'active', contact: 'Dr. Rolf Baumgartner', email: 'r.baumgartner@zurich.com',  city: 'Zurich',     canton: 'ZH', bordereau: 'Generated' },
//   { id: '2', name: 'Swiss Life AG',               code: 'SWLI', products: ['Daily Sickness'],                             activePolicies: 124, monthlyPremium: 890000, status: 'active', contact: 'Claudia Meier',         email: 'c.meier@swisslife.ch',    city: 'Zurich',     canton: 'ZH', bordereau: 'Pending'   },
//   { id: '3', name: 'Helvetia Versicherungen AG',  code: 'HELV', products: ['Professional Liability'],                     activePolicies: 31,  monthlyPremium: 195000, status: 'active', contact: 'Stefan Huber',          email: 's.huber@helvetia.ch',     city: 'St. Gallen', canton: 'SG', bordereau: 'Generated' },
//   { id: '4', name: 'Mobilière Suisse SA',         code: 'MOBI', products: ['Legal Protection'],                           activePolicies: 22,  monthlyPremium: 88000,  status: 'active', contact: 'Anne-Marie Dupont',     email: 'am.dupont@mobiliere.ch',  city: 'Bern',       canton: 'BE', bordereau: 'Generated' },
//   { id: '5', name: 'Axa Winterthur AG',           code: 'AXAW', products: ['Professional Liability', 'Daily Sickness'],   activePolicies: 55,  monthlyPremium: 310000, status: 'active', contact: 'Markus Gyr',            email: 'm.gyr@axa.ch',            city: 'Winterthur', canton: 'ZH', bordereau: 'Pending'   },
// ];

const toCarrier = c => ({
  id: c._id || c.id,
  name: c.name,
  code: c.code || '',
  products: c.products || [],
  activePolicies: c.activePolicies || 0,
  monthlyPremium: c.monthlyPremium || 0,
  status: c.status || 'active',
  contact: c.contact,
  email: c.email,
  phone: c.phone,
  address: c.address,
  city: c.city,
  canton: c.canton,
  bordereau: c.bordereau || 'Pending',
  bordereauHistory: c.bordereauHistory || [],
  bordereauxConfig: c.bordereauxConfig || { frequency: 'monthly', format: 'xlsx', dayOfMonth: 5, autoSend: false, recipients: [] },
  active: c.active !== false,
  createdAt: c.createdAt,
});

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const useRiskCarriersFunctions = () => {
  useLocale();
  const [carriers, setCarriers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);

  const fetchCarriers = useCallback(async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/risk-carriers`, { params: { limit: 200 }, withCredentials: true });
      if (resp.data?.data?.length > 0) setCarriers(resp.data.data.map(toCarrier));
    } catch {
      /* empty state on error */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCarriers();
  }, [fetchCarriers]);

  const filtered = carriers.filter(c => {
    const q = search.toLowerCase();
    return !q || c.name?.toLowerCase().includes(q) || c.city?.toLowerCase().includes(q) || c.code?.toLowerCase().includes(q);
  });

  const handleCreate = carrier => {
    setCarriers(prev => [carrier, ...prev]);
  };

  const handleUpdate = updated => {
    setCarriers(prev => prev.map(c => (c.id === updated.id ? updated : c)));
    setSelected(updated);
  };

  return {
    carriers,
    setCarriers,
    loading,
    setLoading,
    search,
    setSearch,
    selected,
    setSelected,
    showAddModal,
    setShowAddModal,
    fetchCarriers,
    filtered,
    handleCreate,
    handleUpdate,
  };
};

export default useRiskCarriersFunctions;
